<template>
  <!-- The Modal -->
  <div
    id="createModal"
    class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
            title="Create Notification"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="title_en">Title</label>
                      <validation-provider
                        #default="{ errors }"
                        name="Title"
                        rules="required"
                      >
                        <b-form-input
                          id="name_en"
                          v-model="createdNotification.title"
                          name="name_en"
                          :state="errors.length > 0 ? false:null"
                          placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="contentEn">Content</label>
                      <validation-provider
                        #default="{ errors }"
                        name="Content"
                        rules="required"
                      >
                        <template>
                          <b-form-textarea
                            id="contentEn"
                            v-model="createdNotification.body"
                            :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                            placeholder=""
                            rows="5"
                            cols="12"
                          />
                        </template>

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea, BFormDatepicker,
} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vue2Dropzone from 'vue2-dropzone'
import { codeMultiple, codeBasic } from './code'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import notificationsService from '../../../services/notificationsService'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormDatepicker,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        dictRemoveFile: 'Remove',
      },
      createdNotification: {
        title: '',
        body: '',
      },
      codeBasic,
      selected: { title: 'Square' },
      option: [{ title: 'Square' }, { title: 'Rectangle' }, { title: 'Rombo' }, { title: 'Romboid' }],
    }
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // eslint-disable-next-line
          notificationsService.post(this.createdNotification)
            .then(response => {
              this.$emit('refresh', 'true')

              /* Reset Inputs */
              this.createdNotification= {
                title: '',
                body: '',
              },
              /* Reset Dropzone Area */
              /* Close Modal */
              $('#createModal').modal('hide')
              if (response && response.status === 200) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: 'Notification Is Created Successfully !',
                  },
                })
              }
              /* Hide Spinner */
              this.loading = false
            })
            .catch(
              function (error) {
                $('#createModal').modal('hide')
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'Error',
                    text: 'Error !',
                  },
                })
                return Promise.reject(error)
              },
            )
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
label{
  font-weight: bold;
}
</style>
